export default __webpack_public_path__ + "static/media/evreux6.d8e7548f.jpg";